import type { VariantProps } from 'class-variance-authority'

import { useFormContext } from '@/frontend/components/form/form-context'
import { Button, type buttonVariants } from '@/frontend/components/ui/button'

interface SubmitButtonProps
  extends React.ComponentProps<typeof Button>,
    VariantProps<typeof buttonVariants> {
  children?: React.ReactNode
}

export function SubmitButton({ children = 'Submit', disabled, ...props }: SubmitButtonProps) {
  const form = useFormContext()

  return (
    <form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting] as const}>
      {([canSubmit, isSubmitting]) => (
        <Button
          size="lg"
          type="submit"
          disabled={disabled || !canSubmit || isSubmitting}
          {...props}
        >
          {isSubmitting ? 'Submitting...' : children}
        </Button>
      )}
    </form.Subscribe>
  )
}
